module Cfnc
{
    "use strict";

    export class SavedSearch
    {
        name: string;
        filters: Array<any>;
        
        constructor( name: string, filters: Array<any> )
        {
            this.name = name;
            
            this.filters = filters;
            
        }
    }
}